import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AuthService } from '../../../../auth/services/auth.service';
import { SpendingGroup } from '../../../models/spending-group.model';
import { DataFiltersService } from '../../../services/data-filters.service';
import { SystemGroupsService } from '../../../services/system-groups.service';
import { TooltipOptions } from 'marketpro-design-lib';

@Component({
  selector: 'mpro-spending-group-container',
  templateUrl: './spending-group-container.component.html',
  styleUrls: [
    './../dropdown-common.scss',
    './spending-group-container.component.scss',
  ],
})
export class SpendingGroupContainerComponent implements OnInit {
  @ViewChild('tooltip')
  public tooltip: ElementRef;

  public tooltipOptions: TooltipOptions = {
    type: 'interactive',
    title: '',
    interactiveText: '',
  };

  public openedGroup: SpendingGroup = new SpendingGroup();

  @Input() public inputValue: string = '';
  @Input() public systemGroups: SpendingGroup[] = [];

  // might not need 2 emitters
  @Output() public groupClicked: EventEmitter<SpendingGroup> =
    new EventEmitter();

  constructor(
    public systemGroupsService: SystemGroupsService,
    public authService: AuthService,
    private dataFiltersService: DataFiltersService
  ) {}

  public ngOnInit() {}

  public getGroupColor(spendingGroup: SpendingGroup, shade: number) {
    const color = this.systemGroupsService.getSpendingGroupColorHex(
      spendingGroup.greaterThan,
      spendingGroup.lessThan,
      shade
    );

    return color === '#FFFFFF' ? undefined : color;
  }

  public onGroupClicked(group: SpendingGroup, subGroup: boolean) {
    if (!group.disabled || !group.authDisabled) {
      this.groupClicked.emit(group);
    }
  }

  public isGroupSelected(group: SpendingGroup) {
    if (group.id != undefined) {
      return (
        group.id ===
        this.dataFiltersService.getDataFiltersValue().spendingGroup.id
      );
    }

    return group.displayValue() === this.inputValue;
  }

  showTooltip(element: any, spendingGroup: SpendingGroup) {
    if (spendingGroup.name === 'Extremely poor') {
      this.tooltipOptions.title = `$2 is actually $2.15`;
      this.tooltipOptions.interactiveText = `(international definition of extreme poverty)`;
      this.tooltip.nativeElement.style.top = element.offsetTop - 20 + 'px';
      this.tooltip.nativeElement.style.left = element.offsetLeft - 290 + 'px';

      this.tooltip.nativeElement.hidden = false;
    }
  }

  hideTooltip() {
    this.tooltip.nativeElement.hidden = true;
  }

  public groupArrowClicked(group: SpendingGroup, showSubgroups: boolean) {
    this.openedGroup.opened = false;
    group.opened = showSubgroups;
    this.openedGroup = group;
  }
}
